<template>
  <div>
    <woot-modal-header-v2
      :header-title="$t('AGENT_MGMT.DELETE.CONFIRM.TITLE')"
      :header-content="headerContent"
    >
      <template #titleIcon>
        <span class="material-symbols-outlined text-icon-primary font-[300]">
          delete
        </span>
      </template>
    </woot-modal-header-v2>
    <div class="px-6">
      <div
        class="px-3 py-2 flex flex-row items-center gap-3 min-w-[429px] bg-gray-50 rounded-[8px]"
      >
        <div class="agent-avatar">
          <thumbnail
            :src="agent.thumbnail"
            class="columns"
            :username="agent.name"
            size="32px"
            :status="agent.availability_status"
          />
        </div>
        <div>
          <div class="space-x-2 leading-[22px]">
            <span class="text-sm text-primary">
              {{ agent.name }}
            </span>
            <span
              v-if="agent.operation_bot"
              class="semantic-tag small tag-mute-01 text-xs"
            >
              {{ $t('SEARCH.BOT_LABEL') }}
            </span>
          </div>
          <div class="text-gray-500 text-xs">{{ agent.email }}</div>
        </div>
      </div>
    </div>
    <div class="flex flex-row justify-end gap-2 pt-7 pb-6 px-6 w-full">
      <woot-button
        color-scheme="secondary"
        class="cancel-btn button clear text-base px-5 py-[11px] leading-[20px] h-[48px] font-[400]"
        @click="closeDeletePopup"
      >
        {{ $t('AGENT_MGMT.DELETE.CONFIRM.NO') }}
      </woot-button>

      <woot-button
        color-scheme="alert"
        class="button-filled text-base px-5 py-[11px] font-[400] h-[unset]"
        variant=""
        @click="confirmDeletion"
      >
        {{ this.$t('AGENT_MGMT.DELETE.CONFIRM.YES') }}
      </woot-button>
    </div>
  </div>
</template>
<script>
import Thumbnail from '../../../../components/widgets/Thumbnail.vue';

export default {
  components: {
    Thumbnail,
  },
  props: {
    closeDeletePopup: {
      type: Function,
      required: true,
    },
    agent: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    headerContent() {
      return `<div class='text-slate-800 text-base mt-[10px]'>
        ${this.$t('AGENT_MGMT.DELETE.CONFIRM.MESSAGE', {
          agentName: this.agent.name,
        })}
      </div>`;
    },
  },
  methods: {
    confirmDeletion() {
      this.loading = true;
      this.closeDeletePopup();
      this.deleteAgent(this.agent.id);
    },
    async deleteAgent(id) {
      try {
        await this.$store.dispatch('agents/delete', id);
        this.showAlert(this.$t('AGENT_MGMT.DELETE.API.SUCCESS_MESSAGE'));
      } catch (error) {
        this.showAlert(this.$t('AGENT_MGMT.DELETE.API.ERROR_MESSAGE'));
      }
    },
    // Show SnackBar
    showAlert(message) {
      this.loading = false;
      bus.$emit('newToastMessage', message);
    },
  },
};
</script>
